/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_ReadonlyInputs */



/**
* | output |
* | --- |
* | "Set by your organisation." |
*
* @param {Settings_Template_ReadonlyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_readonly = /** @type {((inputs?: Settings_Template_ReadonlyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_ReadonlyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vastgelegd door je organisatie.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Défini par votre organisation.")
	return /** @type {LocalizedString} */ ("Set by your organisation.")
});